import * as React from 'react'
import { ImageAndText, Image, Text } from 'components/common/ImageAndText'
import { Stat, StatList } from 'components/common/Stat'
import SanityBlock from 'components/common/SanityBlock'

const SafetyStats = ({ title, _rawDescription, image, children }) => (
  <ImageAndText className="bg-suede-black text-white">
    {image && <Image image={image} alt={title} grayscale />}

    <Text>
      <h2 className="h0">{title}</h2>

      <StatList>
        {children || <>
          <Stat number={0.61} text="EMR Rating" />
          <Stat number={14} arrow="up" text="Safety Certifications" />
        </>}
      </StatList>

      {_rawDescription && <SanityBlock body={_rawDescription} />}
    </Text>
  </ImageAndText>
)

export default SafetyStats
